import ymService from './ym';

class Tracker {
  constructor({
    services = []
  }) {
    this.services = services;
  }
  sendEvent(eventName, params = {}) {
    console.log('tracker', eventName, params);
    this.services.forEach(service => service.sendEvent(eventName, params));
  }

  sendEventOnce(eventName, params = {}) {
    const isSent = localStorage.getItem(eventName);

    if (isSent) {
      return;
    }

    localStorage.setItem(eventName, '1');
    this.sendEvent(eventName, params);
  }

  sendVariantEvent({ variants, key, selected, eventData = {} }) {
    const variant = Object.values(variants).find(item => item.key === key);

    if (variant && variant.event) {
      this.sendEvent(variant.event, {
        ...eventData,
        selected
      });
    }
  }
}

const tracker = new Tracker({
  services: [ymService]
});

export default tracker;



// WEBPACK FOOTER //
// ./src/services/tracker.js